const BaseRoutingConstants = {
  // Tools
  Pricing: `pricing`,
  PickAndPacking: `picking-and-packing`,
  PackageContents: `package-contents`,

  // Orders
  OrderHistory: `my-orders`,
  SmartSend: 'sold-items',
  InTransit: 'in-transit',

  // Account
  AccountLinking: `accounts`,
  Billing: `billing`,
  Settings: `settings`,

  // Rewards
  Referrals: 'referrals',
  Rewards: 'rewards',

  // Support
  Support: 'support-centre',
  Enquiry: `enquiry`,
  Cancellations: 'cancellations',
  Claims: 'claims',
  SupportTickets: 'support',
  SupportTickets_Raise: 'enquiry',

  // Apps
  AppTariffCodes: 'app/tariff-codes',
  AppMobilePicking: 'app/mobile-picking',
  AppPickingList: 'app/picking-list',

  // Other / Standalone / Legacy
  AccountConcerns: `account-concerns`,
  Surcharges: `surcharges`,
  CustomerFeatures: `customer-features`,
  MyAccount: ``,
  AwaitingDispatch: 'marketplace-tracking',
  RuleManager: 'rulemanager',
  Manifests: 'manifests',
  SmartSendSetup: 'smartsend-setup',
  SmartSendSetupAbort: 'smartsend-setup-abort',
  Analytics: 'analytics',
  CsvMapping: 'csv-mapping',
  SavedAddresses: `addresses`
};

export const RoutingConstantsTabs = {
  StatementsAndInvoices: `statements-and-invoices`,
  PrePay: `prepay`,
  Profile: `profile`,
  Settings: `user-settings`,
  CommunicationPreferences: `communication-preferences`,
  OrdersDashboard: `orders`
};

export const RoutingConstants = {
  ...BaseRoutingConstants,

  // Billing Sub Navigation
  Billing_PrePay: `${BaseRoutingConstants.Billing}#${RoutingConstantsTabs.PrePay}`,
  Billing_Statements: `${BaseRoutingConstants.Billing}#${RoutingConstantsTabs.StatementsAndInvoices}`,

  // Profile Sub Navigation
  Settings_Profile: `${BaseRoutingConstants.Settings}#${RoutingConstantsTabs.Profile}`,
  Settings_CommunicationPreferences: `${BaseRoutingConstants.Settings}#${RoutingConstantsTabs.CommunicationPreferences}`,
  Settings_Settings: `${BaseRoutingConstants.Settings}#${RoutingConstantsTabs.Settings}`,

  // Analytics Sub Navigation
  Analytics_OrdersDashboard: `${BaseRoutingConstants.Analytics}#${RoutingConstantsTabs.OrdersDashboard}`
};

export const RoutingConstantsLabels = {
  [RoutingConstants.OrderHistory]: 'Booked Items',
  [RoutingConstants.Enquiry]: 'Enquiry',
  [RoutingConstants.SmartSend]: 'Smart Send',
  [RoutingConstants.SmartSendSetup]: 'Smart Send Setup',
  [RoutingConstants.SmartSendSetupAbort]: 'Abort Setup',
  [RoutingConstants.Analytics]: 'Smart Send Dashboard',
  [RoutingConstants.InTransit]: 'In Transit',
  [RoutingConstants.CsvMapping]: 'CSV Mapping',
  [RoutingConstants.PickAndPacking]: 'Picking and Packing',
  [RoutingConstants.PackageContents]: 'Picking and Packing',
  [RoutingConstants.AccountConcerns]: 'Account Concerns',
  [RoutingConstants.MyAccount]: 'My Account',
  [RoutingConstants.AwaitingDispatch]: 'Marketplace Tracking',
  [RoutingConstants.Pricing]: 'Pricing',
  [RoutingConstants.RuleManager]: 'Rule Manager',
  [RoutingConstants.Manifests]: 'Manifests',
  [RoutingConstants.Cancellations]: 'Cancellations',
  [RoutingConstants.Claims]: 'Claims',
  [RoutingConstants.SupportTickets]: 'Support Tickets',
  [RoutingConstants.SupportTickets_Raise]: 'Raise Support Ticket',
  [RoutingConstants.AccountLinking]: 'Integrations',
  [RoutingConstants.Surcharges]: 'Surcharges',
  [RoutingConstants.Billing]: 'Billing',
  [RoutingConstants.CustomerFeatures]: 'Settings',
  [RoutingConstants.Settings]: 'Settings',
  [RoutingConstants.AppTariffCodes]: 'Tariff Codes',
  [RoutingConstants.AppMobilePicking]: 'Mobile Picking',
  [RoutingConstants.AppPickingList]: 'Picking List',
  [RoutingConstants.Support]: 'Home',
  [RoutingConstants.Referrals]: 'Referrals',
  [RoutingConstants.Rewards]: 'Rewards',
  [RoutingConstants.SavedAddresses]: 'Saved Addresses',
  [RoutingConstantsTabs.Profile]: 'Profile',
  [RoutingConstantsTabs.CommunicationPreferences]: 'Communication Preferences',
  [RoutingConstantsTabs.StatementsAndInvoices]: 'Statements and Invoices',
  [RoutingConstantsTabs.PrePay]: 'PrePay',
  [RoutingConstantsTabs.Settings]: 'Settings'
};
